import React, { PureComponent } from 'react';
import { getProvince } from '../../api/school'
import './Start.less'
import {setDocTitle} from "../../utils/tools";

const STORAGE_KEY = 'selected_province';

class Start extends PureComponent {
  constructor(props) {
    super(props);
    let selectedProvince = localStorage.getItem(STORAGE_KEY);
    this.state = {
      provinces: [],
      selected: selectedProvince === null ? "" : parseInt(selectedProvince, 10),
    }
  }

  componentDidMount() {
    const host = window.location.host;
    if(host==='xs.shijieu.cn'){
      setDocTitle('试界云学生端');
    }
    else if(host==='xs.t.shijieu.cn'){
      setDocTitle('试界云学生端-测试版');
    }
    else {
      setDocTitle('试界云测试端');
    }
    getProvince().then(({ data }) => {
      this.setState({
        provinces: data,
      });
    })
  }

  handleNext() {
    const { history } = this.props;
    const { selected } = this.state;
    localStorage.setItem(STORAGE_KEY, selected);
    history.push(`./subjects/${selected}`);
  }

  render() {
    const { provinces, selected } = this.state;
    return (
      <div className="subject-choice-wrapper">
        <div className="subject-choice-inner">
          <h1><span>开始新的</span><br />选科决策填报</h1>
          <p className="notice">
            请结合自己不同学科的成绩情况，与意向专业院校的分科要求，与父母老师讨论后，提交分科决策
        </p>
          <p className="notice">
            建议先使用<a href="/chooseCourse/stageOne">新高考选科查询系统</a>了解各种决策可能性带来的机会和风险
        </p>
          <div className="selection-area">
            <label className="province-label">请确认你的高考地</label>
            <br />
            <select value={selected} onChange={(e) => this.setState({ selected: e.target.value })}>
              <option value="">请选择</option>
              {provinces.map(d => <option key={d.id} value={d.id}>{d.name}</option>)}
            </select>
          </div>
        </div>
        <div className="subject-choice-bottom">
          <button className="primary full" disabled={!selected} onClick={this.handleNext.bind(this)}>
            {!selected ? '选择省份' : '已经充分考虑，开始填报'}
          </button>
        </div>
      </div>
    );
  }
}

export default Start;



// WEBPACK FOOTER //
// ./src/pages/SubjectChoice/Start.js